import { App, ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import kkKZ from 'antd/lib/locale/kk_KZ';
import ruRU from 'antd/lib/locale/ru_RU';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Languages } from '@/shared/constants';
import { useAppSelector } from '@/store';

import { getAntdTheme } from './helpers/getAntdTheme';

interface IProps {
  children: React.ReactNode;
}

const ThemeProvider: React.FC<IProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const { theme } = useAppSelector((state) => state.app);

  const locale = useMemo(() => {
    switch (currentLang) {
      case Languages.ru:
        return ruRU;
      case Languages.en:
        return enUS;
      case Languages.kk:
        return kkKZ;
      default:
        return ruRU;
    }
  }, [currentLang]);

  return (
    <ConfigProvider locale={locale} theme={getAntdTheme(theme)}>
      <App component={false}>{children}</App>
    </ConfigProvider>
  );
};

export default ThemeProvider;
